import React from 'react'

const NotFound = () => {
    return (
        <div className="container">
            <div className="col-12 col-lg-10 col-xl-8">
                <h2>Not found</h2>
                <p>The page you tried to access does not exist.</p>
            </div>
        </div>
    )
}

export default NotFound
